import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { faSpinner } from '@awesome.me/kit-fe06945d58/icons/sharp-duotone/solid';

@Component({
  selector: 'app-wait-modal',
  standalone: false,
  templateUrl: 'waitmodal.component.html',
})
export class WaitModalComponent {
  spinner = faSpinner;

  constructor(public activeModal: NgbActiveModal) { }
}
